// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const TranslatedOption = props =>
    <FormattedMessage id={props.text}>
        {formattedMessage =>
            <option
                className='translated-option'
                value={props.value}
            >
                {formattedMessage}
            </option>
        }
    </FormattedMessage>;

TranslatedOption.displayName = 'TranslatedOption';
TranslatedOption.propTypes = {
    text: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
};

export default TranslatedOption;



// WEBPACK FOOTER //
// ./src/shared/components/translated-option/index.js